<script>
    import { Bar } from "svelte-chartjs";

    import {
        Chart,
        Title,
        Tooltip,
        Legend,
        BarElement,
        CategoryScale,
        LinearScale,
    } from "chart.js";

    Chart.register(
        Title,
        Tooltip,
        Legend,
        BarElement,
        CategoryScale,
        LinearScale,
    );

    export let title = "No title specified",
        width = "100",
        height = "100",
        isResponsive = false,
        borderWidth = Number(0),
        labels = [],
        chartData = [],
        backgroundColorArr = [],
        borderColorArr = [];

    const data = {
        labels: labels.length ? labels : [],
        datasets: [
            {
                label: title,
                data: chartData.length ? chartData : [],
                backgroundColor: backgroundColorArr.length
                    ? backgroundColorArr
                    : [
                          "rgba(255, 134,159, 0.4)",
                          "rgba(98,  182, 239, 0.4)",
                          "rgba(255, 218, 128, 0.4)",
                          "rgba(113, 205, 205, 0.4)",
                          "rgba(170, 128, 252, 0.4)",
                          "rgba(255, 177, 101, 0.4)",
                      ],
                borderWidth: borderWidth ? borderWidth : 2,
                borderColor: borderColorArr.length
                    ? borderColorArr
                    : [
                          "rgba(255, 134, 159, 1)",
                          "rgba(98,  182, 239, 1)",
                          "rgba(255, 218, 128, 1)",
                          "rgba(113, 205, 205, 1)",
                          "rgba(170, 128, 252, 1)",
                          "rgba(255, 177, 101, 1)",
                      ],
            },
        ],
    };

    const getOptions = (isResponsive) => {
        return isResponsive
            ? { responsive: true }
            : { maintainAspectRatio: false };
    };

    const getClass = (width, height) => {
        return `w-${width} h-${height}`;
    };
</script>

<div class={getClass(width, height)}>
    <Bar {data} options={getOptions(isResponsive)} />
</div>
